import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=c963f0f6&scoped=true"
import script from "./sex.vue?vue&type=script&lang=js"
export * from "./sex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963f0f6",
  null
  
)

export default component.exports